export default __webpack_public_path__ + "ae6cfa5e91551d038b01bd6af8282be9.png";